import {useParams} from 'react-router-dom'
import { Space } from 'antd'
import styles from './RequestDetails.module.scss'
import {
  // Box, Button, UserAvatar,
  // IconButton, DotsIcon
  Block,
  Text,
  IconTitle,
  RequestFifthIcon, 
} from 'common/components'
import {formatMoney} from 'common/helpers'
import {useGetJournalRequest} from '../api.journal'

export default function JournalRequestDetails() {
  const params = useParams()
  const {data: request, isRefetching} = useGetJournalRequest(params.uuid)
  // console.log(request)
  return (
    !!isRefetching ? null :
    <Block className={styles.root} type="white">
      <div className={styles['journal-actions']}>
        <IconTitle icon={<RequestFifthIcon />}>
          Journal
        </IconTitle>
        {/* <IconButton className={styles.edit} >
          <DotsIcon />
        </IconButton> */}
      </div>

      <Space size={20}>
        <div style={{width: '122px'}}>
          <Text mb={8} size="xs" color="grayer" weight="medium">Reference</Text>
          <Text size="xl" color="black"  weight="medium">{request.type}</Text>
        </div>
        <div>
          <Text mb={8} size="xs" color="grayer" weight="medium">Amount</Text>
          <Text size="xl" color="black"  weight="medium">{formatMoney(request.amount)}</Text>
        </div>
      </Space>

      <Text mb={4} mt={24}  size="2xs" color="black" weight="demiBold">Statement note</Text>
      <Text mb={24} size="xs"  color="black">{request.statementNote}</Text>

      <Text mb={4}  size="2xs" color="black" weight="demiBold">Comments</Text>
      <Text mb={24} size="xs"  color="black">
        {request.comment}
      </Text>
    </Block>
  )
}
